import { Component } from '@angular/core';

@Component({
  selector: 'app-success-sent',
  templateUrl: './success-sent.component.html',
  styleUrls: ['./success-sent.component.scss']
})
export class SuccessSentComponent {}
